// Header rows with tanggal / jam and the vehicle. Mobil does not show a trailer field here.
const EditorHeaderTopRows = ({
  headerElTanggal,
  headerElJam,
  headerElVehicle,
}) => {
  return (
    <>
      <div className="row-start-center w-full gap-3 flex-wrap sm:flex-nowrap">
        {/* on a narrow screen the jam goes under the tanggal, side by side the date gets cut off */}
        <div className="row-start-start w-full gap-3 flex-wrap sm:flex-nowrap">
          {headerElTanggal}
          {headerElJam}
        </div>
      </div>
      <div className="row-start-center w-full gap-3 flex-wrap sm:flex-nowrap">
        {headerElVehicle}
      </div>
    </>
  );
};

export default EditorHeaderTopRows;
